export default __webpack_public_path__ + "static/head_peter-ed3a7645a40c6741d43f692b1c12d1f9.jpg";